export const PLACEHOLDER_SIZE = '#JS-PLACEHOLDER-SIZE#';
export const PLACEHOLDER_POS = '#JS-PLACEHOLDER-POS#';

export const isTeaserPlaying = (element) =>
  element.classList.contains('js-teaser-playing');

export const markTeaserAsPlaying = (element) => {
  element.classList.add('teaser--active-media', 'js-teaser-playing');
  element.querySelector('.play-icon')?.classList.add('play-icon--stop');
};

export const markTeaserAsNotPlaying = (element) => {
  element.classList.remove('teaser--active-media', 'js-teaser-playing');
  element.querySelector('.play-icon')?.classList.remove('play-icon--stop');
};

export const GET_TEASER_SIZE_FROM_CSS = (element) =>
  window
    .getComputedStyle(element, '::before')
    .getPropertyValue('content')
    .replace(/"/g, '')
    .replace('type-', 'size-');
